import { startsWith } from 'lodash';

export const TEMPLATE_INPUT_NAME_PREFIX = 'status_user_message_input_';

export function isStatusUserMessageTemplateKey(key) {
  return startsWith(key, TEMPLATE_INPUT_NAME_PREFIX);
}
